<ion-grid
	class="center"
	*ngIf="participateCompany$ | async as participateCompany"
>
	<ng-container *ngIf="participateCompany.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ng-container *ngIf="!participateCompany.isSkeleton">
		<ion-row>
			<ion-col>
				<ion-grid class="max-w-1336">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid
								id="gridContainer"
								[dataSource]="participateCompany.data"
								[allowColumnResizing]="true"
								[columnAutoWidth]="true"
								[showBorders]="true"
							>
								<dxo-search-panel
									[visible]="true"
									[width]="240"
									placeholder="Search..."
								></dxo-search-panel>
								<dxo-header-filter [visible]="true"></dxo-header-filter>
								<dxo-column-chooser
									[enabled]="true"
									mode="select"
								></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column
									caption="Actions"
									dataField="id"
									[allowFiltering]="false"
									[allowSorting]="false"
									cellTemplate="cellTemplate"
								>
								</dxi-column>

								<dxi-column dataField="name" caption="Name"></dxi-column>
								<dxi-column
									cellTemplate="cellTemplateImage"
									caption="Logo"
								></dxi-column>

								<dxi-column dataField="url" caption="Url"></dxi-column>
								<dxi-column
									caption="approve/reject (for jobfair)"
									dataField="id"
									[allowFiltering]="false"
									[allowSorting]="false"
									cellTemplate="cellTemplate2"
									*ngIf="jobFairName.id !== specialFair"
								>
								</dxi-column>

								<div *dxTemplate="let d of 'cellTemplate2'">
									<dxi-item>
										<ion-buttons class="right">
											<ion-select
												interface="popover"
												[value]="d.data.status"
												(ionChange)="handleChange($event,d.data.jobFairCompanyId)"
											>
												<ion-select-option
													value="approved"
													*ngIf="d.data.status !== 'rejected' && d.data.status !== 'pending'"
													>Approved</ion-select-option
												>
												<ion-select-option
													value="approved"
													*ngIf="d.data.status === 'rejected' || d.data.status === 'pending'"
													>Approve</ion-select-option
												>
												<ion-select-option
													value="rejected"
													*ngIf="d.data.status !== 'approved' && d.data.status !== 'pending'"
													>Rejected</ion-select-option
												>
												<ion-select-option
													value="rejected"
													*ngIf="d.data.status === 'approved' || d.data.status === 'pending'"
													>Reject</ion-select-option
												>
												<ion-select-option
													value="pending"
													*ngIf="d.data.status === 'pending'"
													>Pending</ion-select-option
												>
											</ion-select>
										</ion-buttons>
									</dxi-item>
								</div>
								<dxi-column
									*ngIf="jobFairName.id === specialFair"
									dataField="jobfairName"
									caption="JobFairSelected"
								></dxi-column>

								<div *dxTemplate="let d of 'cellTemplate'">
									<a
										appConfirmBox
										(learnDelete)="removeParticipateCompany(d.data)"
										title="Delete Company"
										subTitle="Are you sure you want to delete your Company ?"
										class="Body_S text-right cursor"
									>
										Delete</a
									>
								</div>

								<div
									*dxTemplate="let d of 'cellTemplateImage'"
									class="text-center"
								>
									<img [src]="d.data.logoUrl" class="logoUrl" />
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<ng-container *ngIf="allCompany$ | async as allCompany">
												<ion-button (click)="addParticipate(allCompany)"
													><ion-icon name="add-outline"></ion-icon
												></ion-button>
											</ng-container>
										</div>
									</dxi-item>

									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Add companies</p>
										</div>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>
		</ion-row>
	</ng-container>
</ion-grid>
